import { types } from "../../types/types"
import { startAlerta } from "../ui/alertas"
import { finishSpinner, startSpinner } from "../ui/spinner"
import ContratacionesService from '../../services/ContratacionesService';
import { handleErrorApi } from "../../helpers/randoms";

export const getEstadosLegalesEfector = () => async (dispatch, getState) => {
    try {
        dispatch({ type: types.contratacionesTraerEstadosLegalesStart })
        const response = await ContratacionesService.traerEstadosLegales(getState().contrataciones.dataContrato.idEfectorFacturacion)
        const body = await response.json()
        if (response.ok) {
            dispatch({
                type: types.contratacionesTraerEstadosLegalesSuccess,
                payload: body
            })
        } else {
            throw body
        }
    } catch (error) {
        dispatch({ type: types.contratacionesTraerEstadosLegalesError })
        handleErrorApi(dispatch, error, "Error al traer los estados legales", "Ha ocurrido un error. Intente nuevamente")
    }
};

export const contratacionesEstadoLegalUpload = (data) => {
    return async (dispatch, getState) => {
        try {
            dispatch(startSpinner())
            const { dataContrato } = getState().contrataciones;
            data.idEfectorFacturacion = dataContrato.idEfectorFacturacion;
            const response = await ContratacionesService.guardarEstadoLegal(data);
            const body = await response.json();
            if (response.ok) {
                dispatch(getEstadosLegalesEfector());
                dispatch(finishSpinner());
                dispatch(startAlerta("Estado Legal Guardado Exitosamente", 'success', 'Comando Exitoso'));
            } else {
                throw body;
            }
        } catch (error) {
            dispatch(finishSpinner());
            handleErrorApi(dispatch, error, "Error al guardar Estado Legal", "Ha ocurrido un error. Intente nuevamente")
        }
    }
}

export const contratacionesEstadoLegalDelete = (idEfectorEstadoLegal) => {
    return async (dispatch) => {
        dispatch(startSpinner())
        try {
            let response = await ContratacionesService.borrarEstadoLegal(idEfectorEstadoLegal)
            const body = await response.json()
            if (response.ok) {
                dispatch(getEstadosLegalesEfector());
                dispatch(finishSpinner())
                dispatch(startAlerta("Estado Legal borrado exitosamente", 'success', 'Comando Exitoso'));
            } else {
                throw body;
            }
        } catch (error) {
            dispatch(finishSpinner())
            handleErrorApi(dispatch, error, "Error al eliminar Estado Legal", "Ha ocurrido un error. Intente nuevamente")
        }
    }
}

export const confirmAcuerdoJudicial = (data, setAcuerdo) => {
    return async (dispatch) => {
        dispatch(startSpinner())
        try {
            const response = await ContratacionesService.confirmAcuerdoJudicial(data)
            const body = await response.json()
            if (response.ok) {
                dispatch(finishSpinner())
                dispatch(startAlerta(
                    `Acuerdo judicial ${data.acuerdoJudicial ? "seleccionado" : "deseleccionado"} con exito`,
                    'success',
                    'Comando Exitoso'
                ));
                setAcuerdo();
            } else {
                throw body;
            }
        } catch (error) {
            dispatch(finishSpinner())
            handleErrorApi(dispatch, error, "Error al eliminar Estado Legal", "Ha ocurrido un error. Intente nuevamente")
        }
    }
}

export const getAreasLegales = () => async (dispatch) => {
    try {
        dispatch({ type: types.contratacionesTraerAreasLegalesStart })
        const response = await ContratacionesService.traerAreasLegales()
        const body = await response.json()
        if (response.ok) {
            dispatch({
                type: types.contratacionesTraerAreasLegalesSuccess,
                payload: body
            })
        } else {
            throw body
        }
    } catch (error) {
        dispatch({ type: types.contratacionesTraerAreasLegalesError })
        handleErrorApi(dispatch, error, "Error al traer areas legales", "Ha ocurrido un error. Intente nuevamente")
    }
};